import React, { Component } from 'react'
import CanvasDraw from "react-canvas-draw";
class FirmaCanvas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editando: true,
            firmaPreview: props.value || null
        };
        this.saveableCanvas = null;
    }

    handleClear = () => {
        if (this.saveableCanvas) this.saveableCanvas.clear();
        this.setState({ firmaPreview: null, editando: true });
        if (this.props.onSave) this.props.onSave(null);
    };

    handleChange = () => {
        if (this.saveableCanvas) {
            this.saveableCanvas.canvas.drawing.toBlob(blob => {
                const url = URL.createObjectURL(blob);
                this.setState({ firmaPreview: url, editando: true });
                if (this.props.onSave) this.props.onSave(blob);
            }, "image/png");
        }
    };

    render() {
        const { disabled } = this.props;
        return (
            <div className="form-control">
                {this.state.editando && !disabled && (
                    <>
                        <button
                            className="action btn btn-icon text-fleet text-danger btn-sm btn-dt-grid pull-right"
                            onClick={e => { e.preventDefault(); this.handleClear(); }}
                            title="Eliminar"
                        >
                            <i className="fa fa-trash fa-xs"></i>
                        </button>
                        <br /><br />
                        <CanvasDraw
                            className="img-fluid"
                            ref={c => (this.saveableCanvas = c)}
                            lazyRadius={10}
                            brushRadius={2}
                            onChange={this.handleChange}
                            canvasWidth={400}
                            canvasHeight={150}
                        />
                    </>
                )}
            </div>
        );
    }
}

export default FirmaCanvas;